var map = {
	"./Arabic.json": "b540",
	"./Chinese.json": "52eb",
	"./Czech.json": "8bd4",
	"./Danish.json": "61fb",
	"./Dutch.json": "8532",
	"./English.json": "0185",
	"./Finnish.json": "878a",
	"./French.json": "7b06",
	"./German.json": "c850",
	"./Greek.json": "8d5b",
	"./Hungarian.json": "e8c4",
	"./Italian.json": "5f20",
	"./Japanese.json": "24ea",
	"./Korean.json": "5941",
	"./Norwegian.json": "e820",
	"./Polish.json": "07e1",
	"./Portuguese.json": "6f3b",
	"./Romanian.json": "eb57",
	"./Russian.json": "7e04",
	"./Slovak.json": "0955",
	"./Slovenian.json": "324a",
	"./Spanish.json": "4bf6",
	"./Swedish.json": "f77b",
	"./Traditional-Chinese.json": "1a2c",
	"./Turkish.json": "73e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c91d";